const LayoutDefault = () =>
  import(/* webpackChunkName: "bonus" */ '@/layouts/LayoutDefault.vue');
const LayoutData = () =>
  import(/* webpackChunkName: "bonus" */ '@/layouts/LayoutData.vue');
const Dashboard = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/dashboard/Index.vue'
  );
// Download Bonus
const DownloadBonus = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/download/Index.vue'
  );
const MasterBarang = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/admin/MasterBarang.vue'
  );
const MasterStockist = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/admin/MasterStockist.vue'
  );
const MasterMitraUsaha = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/admin/master-mitra-usaha/Index.vue'
  );
const MasterUser = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/admin/MasterUser.vue'
  );
const EditMasterMitraUsaha = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/admin/master-mitra-usaha/Edit.vue'
  );
const DataMitraUsaha = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/bonus/DataMitraUsaha.vue'
  );
const DataCashbill = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/bonus/DataCashbill.vue'
  );
const DataCashbillNuera = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/bonus/DataCashbillNuera.vue'
  );
const DataStok = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/bonus/DataStok.vue'
  );
const DataTambahPoint = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/bonus/DataTambahBonus.vue'
  );
const ToolHapusMitraUsaha = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/tool/hapus-mitra-usaha.vue'
  );
const ToolTambahMitraUsaha = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/tool/tambah-mitra-usaha.vue'
  );
const ToolImportCashbill = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/tool/import-cashbill.vue'
  );
const ToolUpdateUplineMitraUsaha = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/tool/update-upline-mitra-usaha.vue'
  );
const ToolGenerateMitraUsahaNd = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/tool/generate-mitra-usaha-nd.vue'
  );
const ExportMitraUsahaNdNe = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/tool/export-mitra-usaha-nd-ne.vue'
  );
// const ToolTaridDataKomisi = () =>
//   import(
//     /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/tool/tarik-data-komisi.vue'
//   );
const AmbilDataBonus = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/ambil-data-bonus.vue'
  );
const LogAutentikasi = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/log-autentikasi.vue'
  );
const LaporanCashbill = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/laporan/LaporanCashbill.vue'
  );
const PoinMItraUsaha = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/bonus/PoinMitraUsaha.vue'
  );
const PerubahanData = () =>
  import(
    /* webpackChunkName: "bonus" */ '@/views/pusat/bonus/perubahan-data/Index.vue'
  );

let root = '/bonus';

export default [
  {
    path: root + '/',
    component: Dashboard,
    meta: {
      auth: true,
      title: 'Dashboard',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/download/',
    component: LayoutData,
    children: [
      {
        path: '',
        component: DownloadBonus,
        meta: {
          auth: true,
          title: 'Download Bonus',
          layout: LayoutDefault,
          breadcrumb: 'Download Bonus',
        },
      },
    ],
  },
  {
    path: root + '/admin/',
    component: LayoutData,
    children: [
      {
        path: 'master-barang',
        component: MasterBarang,
        meta: {
          auth: true,
          title: 'Master Barang',
          layout: LayoutDefault,
          breadcrumb: 'Master Barang',
        },
      },
      {
        path: 'master-stockist',
        component: MasterStockist,
        meta: {
          auth: true,
          title: 'Master Stockist',
          layout: LayoutDefault,
          breadcrumb: 'Master Stockist',
        },
      },
      {
        path: 'master-mitra-usaha',
        component: LayoutData,
        children: [
          {
            path: '',
            component: MasterMitraUsaha,
            name: 'master-mitra-usaha',
            meta: {
              auth: true,
              title: 'Master Mitra Usaha',
              layout: LayoutDefault,
              breadcrumb: 'Master Mitra Usaha',
            },
          },
          {
            path: ':id',
            component: EditMasterMitraUsaha,
            name: 'master-mitra-usaha.edit',
            meta: {
              auth: true,
              title: 'Edit Master Mitra Usaha',
              layout: LayoutDefault,
              breadcrumb: 'Master Mitra Usaha',
            },
          },
        ]
      },
      {
        path: 'master-user',
        component: MasterUser,
        meta: {
          auth: true,
          title: 'Master User',
          layout: LayoutDefault,
          breadcrumb: 'Master User',
        },
      },
    ],
  },
  {
    path: root + '/bonus/',
    component: LayoutData,
    children: [
      {
        path: 'data-mitra-usaha',
        component: DataMitraUsaha,
        meta: {
          auth: true,
          title: 'Data Mitra Usaha',
          layout: LayoutDefault,
          breadcrumb: 'Data Mitra Usaha',
        },
      },
      {
        path: 'data-cashbill',
        component: DataCashbill,
        meta: {
          auth: true,
          title: 'Data Cashbill',
          layout: LayoutDefault,
          breadcrumb: 'Data Cashbill',
        },
      },
      {
        path: 'data-cashbill-nuera',
        component: DataCashbillNuera,
        meta: {
          auth: true,
          title: 'Data Cashbill Nuera',
          layout: LayoutDefault,
          breadcrumb: 'Data Cashbill Nuera',
        },
      },
      {
        path: 'data-stok',
        component: DataStok,
        meta: {
          auth: true,
          title: 'Data Stok',
          layout: LayoutDefault,
          breadcrumb: 'Data Stok',
        },
      },
      {
        path: 'data-tambahan-poin',
        component: DataTambahPoint,
        meta: {
          auth: true,
          title: 'Data Tambahan Poin',
          layout: LayoutDefault,
          breadcrumb: 'Data Tambahan Poin',
        },
      },
      {
        path: 'point-mitra-usaha',
        component: PoinMItraUsaha,
        meta: {
          auth: true,
          title: 'Poin Mitra Usaha',
          layout: LayoutDefault,
          breadcrumb: 'Poin Mitra Usaha',
        },
      },
      {
        path: 'perubahan-data',
        component: PerubahanData,
        meta: {
          auth: true,
          title: 'Perubahan Data',
          layout: LayoutDefault,
          breadcrumb: 'Perubahan Data',
        },
      },
    ],
  },
  // Menu Tool
  {
    path: root + '/tool/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Tool',
    },
    children: [
      {
        path: 'hapus-mitra-usaha',
        component: ToolHapusMitraUsaha,
        meta: {
          auth: true,
          title: 'Hapus Mitra Usaha',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah-mitra-usaha',
        component: ToolTambahMitraUsaha,
        meta: {
          auth: true,
          title: 'Tambah / Update Mitra Usaha',
          layout: LayoutDefault,
        },
      },
      {
        path: 'import-cashbill',
        component: ToolImportCashbill,
        meta: {
          auth: true,
          title: 'Import Cashbill',
          layout: LayoutDefault,
        },
      },
      {
        path: 'update-upline-mitra-usaha',
        component: ToolUpdateUplineMitraUsaha,
        meta: {
          auth: true,
          title: 'Update Upline Mitra Usaha',
          layout: LayoutDefault,
        },
      },
      {
        path: 'generate-mitra-usaha-nd',
        component: ToolGenerateMitraUsahaNd,
        meta: {
          auth: true,
          title: 'Generate Mitra Usaha ND',
          layout: LayoutDefault,
        },
      },
      {
        path: 'export-mitra-usaha-nd-ne',
        component: ExportMitraUsahaNdNe,
        meta: {
          auth: true,
          title: 'Export Mitra Usaha ND dan NE',
          layout: LayoutDefault,
        },
      },
      // {
      //   path: 'tarik-data-komisi',
      //   component: ToolTaridDataKomisi,
      //   meta: {
      //     auth: true,
      //     title: 'Tarik Data Komisi',
      //     layout: LayoutDefault,
      //   },
      // },
    ]
  },
  {
    path: root + '/laporan/',
    component: LayoutData,
    meta: {
      breadcrumb: 'laporan',
    },
    children: [
      {
        path: 'cashbill-mitra-usaha',
        component: LaporanCashbill,
        meta: {
          auth: true,
          title: 'Laporan Cashbill dan Mitra Usaha',
          layout: LayoutDefault,
        },
      },
    ]
  },
  {
    path: root + '/ambil-data-bonus',
    component: AmbilDataBonus,
    meta: {
      auth: true,
      title: 'Ambil Data Bonus',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/log-autentikasi',
    component: LogAutentikasi,
    meta: {
      auth: true,
      title: 'Log Autentikasi',
      layout: LayoutDefault,
    },
  },
];
